const STORAGE_KEY = '2fa_device_trust';

type TrustMap = Record<string, string>;

function readMap(): TrustMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as TrustMap;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(map: TrustMap): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function getDeviceTrustToken(username: string): string | undefined {
  const key = username.trim().toLowerCase();
  if (!key) return undefined;
  return readMap()[key];
}

export function setDeviceTrustToken(username: string, token: string): void {
  const key = username.trim().toLowerCase();
  if (!key || !token) return;
  const map = readMap();
  map[key] = token;
  writeMap(map);
}

export function clearDeviceTrustToken(username: string): void {
  const key = username.trim().toLowerCase();
  if (!key) return;
  const map = readMap();
  if (!(key in map)) return;
  delete map[key];
  writeMap(map);
}
